export const overviewTilePositions = ['main', 'sidebar'] as const

type OverviewTilePosition = typeof overviewTilePositions[number]
export default OverviewTilePosition
